import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-page)' }}>
      <div className="max-w-md w-full p-8 rounded-lg text-center" style={{ background: 'var(--bg-card)' }}>
        <XCircle size={64} className="mx-auto mb-4" style={{ color: '#DC2626' }} />
        <h1 className="heading-2 mb-4">Payment Cancelled</h1>
        <p className="body-large mb-6" style={{ color: 'var(--text-secondary)' }}>
          You cancelled the payment process. No charges were made.
        </p>
        <div className="flex gap-4 justify-center">
          <button onClick={() => navigate('/')} className="btn-secondary">
            Return Home
          </button>
          <button onClick={() => navigate('/checkout')} className="btn-primary">
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;